import React from "react"
import {Input} from "antd"

const TextAreaField = () => <Input rows={4} style={{height: 100}} size="large"></Input>
export default TextAreaField
